import React, {useReducer} from "react";
import PropTypes from "prop-types";

import TextField from "@mui/material/TextField/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const PasswordField = (props) => {
    const {showPasswordIcon = true, ...innerProps} = props;

    const [showPassword, toggleShowPassword] = useReducer((prevState) => !prevState, false);

    return <TextField {...innerProps}
                      type={showPassword ? 'text' : 'password'}
                      InputProps={
                          (showPasswordIcon ? {
                                  endAdornment: <InputAdornment position="end">
                                      <IconButton
                                          aria-label="toggle password visibility"
                                          onClick={toggleShowPassword}
                                          edge="end">
                                          {showPassword ? <VisibilityOff/> : <Visibility/>}
                                      </IconButton>
                                  </InputAdornment>
                              }
                              :
                              {})}/>;
}

PasswordField.propTypes = {
    showPasswordIcon: PropTypes.bool,
};

export default PasswordField;